<template>
  <div class="card">
    <div class="card-header">
      <div class="card-title d-flex align-items-center">
        <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
          <inline-svg src="media/icons/duotune/communication/com007.svg" />
        </span>
        <h3 class="fw-bold m-0 text-gray-800">Ticket</h3>
      </div>
      <div
        v-if="this.modal === true"
        class="btn btn-icon btn-sm btn-active-light-primary mt-6"
        data-bs-dismiss="modal"
        @click="this.$emit('fecharTicket', false)"
      >
        <span class="svg-icon svg-icon-1 svg-icon lh-0">
          <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
        </span>
      </div>
    </div>
    <div class="card-body p-0">
      <div
        v-if="this.errosValidacaoGeral.length"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  {{ value }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="this.user.User.Emitente.tipo_pacote === 0"
        class="notice d-flex bg-light-info rounded border-info border border-dashed mx-9 mt-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-info me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="text-gray-800 fw-bolder">
              Suporte Técnico gratuito por 1 mês (via ticket)
            </div>
            <div class="fs-7 text-gray-600 mt-2">
              {{ this.verificarTempoSuporte() }}
            </div>
          </div>
        </div>
      </div>
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div
            v-if="!this.showFilter"
            class="d-flex align-items-center position-relative my-1"
          >
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisarTicket"
              v-model="tableData.search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid w-250px ps-15"
              placeholder="Pesquisar Ticket"
              @keydown="keydownPesquisa"
              autocomplete="off"
              type="search"
            />
          </div>
        </div>
        <div class="card-toolbar">
          <div
            v-if="checkedTicket.length === 0"
            class="d-flex justify-content-end"
            data-kt-customer-table-toolbar="base"
          >
            <router-link
              v-if="this.adicionar && this.modal === false"
              to="/suporte/ticket/editar"
              class="btn btn-sm btn-primary ms-2"
              ><span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/general/gen041.svg" /></span
              >Adicionar</router-link
            >
          </div>
          <div
            v-else
            class="d-flex justify-content-end align-items-center"
            data-kt-customer-table-toolbar="selected"
          >
            <div class="fw-bolder me-5">
              <span class="me-2">{{ checkedTicket.length }}</span
              >Selecionado(s)
            </div>
            <button
              v-if="this.excluir && this.modal === false"
              type="button"
              class="btn btn-sm btn-danger"
              @click="deleteSelecionados()"
            >
              Excluír Selecionado(s)
            </button>
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="table"
          :table-header="tableHeader"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhum ticket encontrado"
          v-on:checked-rows="checkedTicket = $event"
          :colors="true"
          v-on:double-click="selecionarRegistro($event)"
          v-on:current-row-selected="currentRow = $event"
          :current-row="currentRow"
          @showFilter="this.showFilter = $event"
        >
          <template v-slot:cell-checkbox="{ row: ticket }">
            <div
              class="form-check form-check-sm form-check-custom form-check-solid"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="ticket.id"
                v-model="checkedTicket"
              />
            </div>
          </template>
          <template v-slot:cell-prioridade="{ row: ticket }">
            <div
              class="btn btn-icon w-35px h-35px"
              :class="[
                ticket.prioridade === `1`
                  ? `btn-color-primary`
                  : `btn-color-gray-500`,
              ]"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Importante"
              @click="this.selecionarRegistro(ticket)"
            >
              <span class="svg-icon svg-icon-1 svg-icon lh-0">
                <inline-svg src="media/icons/duotune/general/gen056.svg" />
              </span>
            </div>
          </template>
          <template v-slot:cell-UsuarioNome="{ row: ticket }">
            <div
              class="d-flex align-items-center text-gray-900 min-w-150px min-w-md-175px"
              style="cursor: pointer"
              @click="this.selecionarRegistro(ticket)"
            >
              <div
                v-if="
                  ticket.Usuario &&
                  ticket.Usuario.UsuarioDado &&
                  ticket.Usuario.UsuarioDado.foto
                    ? ticket.Usuario.UsuarioDado.foto
                    : ''
                "
                class="symbol symbol-35px me-3"
              >
                <div
                  class="symbol-label fs-2 fw-bold bg-light-dark"
                  :style="{
                    'background-image': `url(${
                      this.$utils.getUrl() + ticket.Usuario.UsuarioDado.foto
                    })`,
                  }"
                ></div>
              </div>
              <div v-else class="symbol symbol-35px me-3">
                <div :class="['symbol-label fs-2 fw-bold ' + ticket.color]">
                  {{
                    ticket.Usuario && ticket.Usuario.nome
                      ? ticket.Usuario.nome.substring(0, 1).toUpperCase()
                      : ""
                  }}
                </div>
              </div>
              <div>
                <div class="text-dark fw-semibold fs-7 custom-cell">
                  {{
                    ticket.Usuario && ticket.Usuario.nome
                      ? ticket.Usuario.nome
                      : ""
                  }}
                </div>
                <div
                  v-if="this.user.User.TipoUsuario.tipo != 'Usuário'"
                  class="text-muted fw-semibold fs-8 custom-cell"
                >
                  {{
                    ticket.Emitente && ticket.Emitente.cnpj
                      ? "CNPJ: " +
                        this.$utils.setMask(
                          ticket.Emitente.cnpj,
                          "##.###.###/####-##",
                          true
                        )
                      : ""
                  }}
                </div>
              </div>
            </div>
          </template>
          <template v-slot:cell-assunto="{ row: ticket }">
            <div
              class="text-gray-900 fw-bold"
              style="cursor: pointer"
              @click="this.selecionarRegistro(ticket)"
            >
              {{ ticket.assunto }}
            </div>
          </template>
          <template v-slot:cell-createdAt="{ row: ticket }">
            <div class="h-50px">
              <span
                :class="[
                  ticket.situacao ? this.getSituacaoColor(ticket.situacao) : '',
                ]"
                >{{ ticket.situacao }}</span
              >
              <div class="text-muted fw-semibold fs-7 pt-2 pe-1 custom-cell">
                {{
                  this.$utils.formatarDataCustomizadaFusoHorario(
                    ticket.createdAt
                  )
                }}
              </div>
            </div>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
import moment from "moment-timezone";

export default {
  emits: ["selecionarTicket", "fecharTicket"],
  components: {
    Datatable,
  },
  props: {
    modal: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    verificarTempoSuporte() {
      const dataUTC = moment.utc(this.user.User.Emitente.createdAt);
      const timeZone = moment.tz.guess();
      const dataLocal = dataUTC.tz(timeZone);
      const dataAtualUTC = this.$utils.removerFusoHorario(new Date());
      const dataAtualLocal = moment.utc(dataAtualUTC).tz(timeZone);
      const diffDays = dataAtualLocal.diff(dataLocal, "days");

      if (diffDays > 30) {
        return "Expira: Suporte expirado!";
      } else {
        return `Expira: ${30 - diffDays} dias restantes`;
      }
    },
    getSituacaoColor(situacao) {
      if (situacao.toUpperCase() === "FINALIZADO") {
        return "badge badge-success";
      } else if (situacao.toUpperCase() === "EM ANDAMENTO") {
        return "badge badge-info";
      } else if (situacao.toUpperCase() === "PENDENTE") {
        return "badge badge-primary";
      } else {
        return "badge badge-dark";
      }
    },
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(assunto, '" +
          pesquisa +
          "') or contains(Usuario/nome, '" +
          pesquisa +
          "') or contains(Emitente/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') ";
      } else {
        this.tableData.filterOData = "";
      }
    },
    async deleteSelecionados() {
      var alert = await Swal.fire({
        text: "Deseja remover os registros selecionados?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiuCadastro = true;
        this.$refs.table.setLoading(true);
        for (var i = 0; i < this.checkedTicket.length; i++) {
          await this.excluirTicket(this.checkedTicket[i]);
        }
        if (this.excluiuCadastro === true) {
          toast.success("Tickets excluídos com sucesso!", { timeout: 3000 });
        }
        this.$refs.table.load();
      }
    },
    async excluirTicket(id) {
      try {
        await this.$store.dispatch("ticket/deleteTicket", id);
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    async selecionarRegistro(ticket) {
      if (this.modal === true) {
        this.$emit("selecionarTicket", ticket.id);
      } else {
        this.$router.push("/suporte/ticket/editar/" + ticket.id);
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.Ticket.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.Ticket.Excluir") {
            this.excluir = true;
          }
        });
      }
    },
    async keydownPesquisa(e) {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        this.currentRow -= 1;
        if (this.currentRow < 0) {
          this.currentRow = 0;
        }
        this.$refs.table.setCurrentRow(this.currentRow);
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        this.currentRow += 1;
        this.$refs.table.setCurrentRow(this.currentRow);
      } else if (e.key === "Enter") {
        e.preventDefault();
        let ticket = this.$refs.table.getCurrentItemIndex(this.currentRow);
        this.selecionarRegistro(ticket);
      }
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    setTimeout(() => {
      this.nextFocus("txtPesquisarTicket");
    }, 800);
  },
  data() {
    return {
      showFilter: false,
      adicionar: false,
      excluir: false,
      checkedTicket: [],
      currentRow: 0,
      errosValidacaoGeral: [],
      excluiuCadastro: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "",
          key: "prioridade",
          sortable: true,
        },
        {
          name: "",
          key: "UsuarioNome",
          sortingField: "Usuario/nome",
          sortable: true,
        },
        {
          name: "",
          key: "assunto",
          sortable: true,
        },
        {
          name: "",
          key: "createdAt",
          sortable: true,
        },
      ],
      tableData: {
        store: "ticket/getTicketOData",
        selectOData:
          "?$select=id,assunto,prioridade,situacao,createdAt&$expand=Usuario($select=nome;$expand=UsuarioDado($select=foto)),Emitente($select=cnpj)",
        filterOData: "",
        search: "",
        defaultSort: "createdAt desc",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style>
.custom-cell {
  font-weight: 500 !important;
}
</style>
